import { render, staticRenderFns } from "./SfFilter.vue?vue&type=template&id=c1f964ea"
import script from "./SfFilter.vue?vue&type=script&lang=js"
export * from "./SfFilter.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfFilter.vue?vue&type=style&index=0&id=c1f964ea&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "5064365c"
  
)

export default component.exports